/**
 * Array.prototype.filter() などのコールバック関数として使うことで、配列要素からundefined型を排除する
 *
 * 例: arr.map(i => arr2.find(j => i.id === j.id)).filter(notUndefined)
 *
 */
export default function notUndefined<T>(x: T | undefined): x is T {
  return x !== undefined
}
